<template>
  <Nonberusaha :tipe_pemohon="'Pemerintah'" />
</template>

<script>
import Nonberusaha from './Nonberusaha.vue'

export default {
  components: { Nonberusaha },
}
</script>
